import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";

export default function RegisterPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    birthDate: "",
    password: "",
  });

  const API_URL =
    process.env.NODE_ENV === "production"
      ? "https://api.urniidvi.ru"
      : "http://localhost:5000";

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (!res.ok) {
        setError(data.message || "Ошибка регистрации");
        return;
      }

      // ✅ сразу логиним пользователя
      login(data.token, data.role);

      // ✅ редиректим в кабинет
      navigate("/cabinet");
    } catch (err) {
      console.error("Ошибка сети:", err);
      setError("Ошибка сети");
    }
  };

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Регистрация
      </h1>
      {error && <p style={{ color: "red" }}>{error}</p>}

      <form className="reg__form" onSubmit={handleSubmit}>
        <div className="login__div">
          <label className="login__label">ФИО:</label>
          <input
            className="field"
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
          {/*
          <label className="login__label">Дата рождения:</label>
          <input
            className="field"
            type="date"
            name="birthDate"
            value={formData.birthDate}
            onChange={handleChange}
            required
          /> */}
        </div>

        <div className="login__div">
          <label className="login__label">Дата рождения:</label>
          <input
            className="field"
            type="date"
            name="birthDate"
            value={formData.birthDate}
            onChange={handleChange}
            required
          />
        </div>

        <div className="login__div">
          <label className="login__label">Телефон:</label>
          <input
            className="field"
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="login__div">
          <label className="login__label">Email:</label>
          <input
            className="field"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="login__div">
          <label className="login__label">Пароль:</label>
          <input
            className="field"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>

        <button className="login__button" type="submit">
          Зарегистрироваться
        </button>
      </form>
    </section>
  );
}
